// extracted by mini-css-extract-plugin
module.exports = {"searchPanelWrapper":"ViewTireDetails_searchPanelWrapper__2lrxW","searchPanel":"ViewTireDetails_searchPanel__3WsAm","detailsFooter":"ViewTireDetails_detailsFooter__XzpGG"};